import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api"; // Axios con token

export default function BloqueoCompradores() {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);




  const cargarBloqueos = async () => {
    try {
      const res = await API.get("/publicaciones/mis/");
      const publicacionesConBloqueados = res.data.filter(
        (pub) => pub.compradores_bloqueados && pub.compradores_bloqueados.length > 0
      );
      setPublicaciones(publicacionesConBloqueados);
    } catch (err) {
      console.error("Error cargando bloqueos", err);
      setPublicaciones([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarBloqueos();
  }, []);


  // DESBLOQUEAR COMPRADOR

  const desbloquear = async (pubId, compradorId) => {
    const confirmacion = window.confirm(
      "Esta funcionalidad requiere un endpoint específico en el backend que aún no está implementado. ¿Desea continuar de todas formas?"
    );

    if (!confirmacion) return;

    try {
      alert("Endpoint /bloqueos/desbloquear/ no implementado en el backend. Necesitas crear este endpoint para que funcione.");
    } catch (err) {
      console.error("Error desbloqueando comprador", err);
      alert("No se pudo desbloquear el comprador.");
    }
  };

  if (loading)
    return (
      <p className="text-center text-primary mt-10">Cargando datos...</p>
    );

  return (
    <div className="space-y-6">
      {/* ---------- TÍTULO ---------- */}
      <h1 className="text-2xl font-bold text-primary">
        Compradores Bloqueados
      </h1>

      <p className="text-slate-600">
        Aquí puedes gestionar los compradores bloqueados de tus publicaciones.
      </p>

      {/* ---------- LISTADO ---------- */}
      {publicaciones.length === 0 ? (
        <p className="text-slate-500 mt-6">
          No tenés publicaciones con compradores bloqueados.
        </p>
      ) : (
        <div className="grid gap-6 mt-4">
          {publicaciones.map((pub) => (
            <Card key={pub.id} className="space-y-3">
              {/* Info del post */}
              <div className="flex justify-between items-center">
                <div>
                  <p className="uppercase text-xs text-slate-500">
                    {pub.tipo}
                  </p>
                  <h3 className="text-lg font-semibold">{pub.titulo}</h3>
                  <p className="text-sm text-slate-600">
                    Monto:{" "}
                    <b className="text-primary">
                      Gs {pub.monto.toLocaleString("es-PY")}
                    </b>
                  </p>
                  <p className="text-sm text-slate-600">
                    Estado:{" "}
                    <span
                      className={
                        pub.estado === "activo"
                          ? "text-emerald-600"
                          : pub.estado === "pendiente"
                            ? "text-yellow-600"
                            : "text-slate-600"
                      }
                    >
                      {pub.estado.toUpperCase()}
                    </span>
                  </p>
                </div>
              </div>

              <div className="mt-3">
                <h4 className="font-semibold text-primary mb-2">
                  Compradores bloqueados
                </h4>

                {pub.compradores_bloqueados.length === 0 ? (
                  <p className="text-slate-500 text-sm">
                    No hay compradores bloqueados en esta publicación.
                  </p>
                ) : (
                  <div className="space-y-3">
                    {pub.compradores_bloqueados.map((compradorId) => (
                      <div
                        key={compradorId}
                        className="border rounded p-3 bg-slate-50 flex justify-between items-center"
                      >
                        <div>
                          <p className="font-semibold text-slate-700">
                            Comprador ID: {compradorId}
                          </p>
                          <p className="text-xs text-red-600">
                            Bloqueado por pago fallido
                          </p>
                        </div>

                        <Button
                          className="bg-red-600 hover:bg-red-700"
                          onClick={() =>
                            desbloquear(pub.id, compradorId)
                          }
                        >
                          Desbloquear
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
